import { useEffect } from 'react';

const useFcmToken = () => {
  useEffect(() => {
    const handleFCMTokenUpdate = (event) => {
      const token = event.detail?.token || window.fcmToken;
      if (token) {
        window.fcmToken = token;
        try {
          localStorage.setItem('fcmToken', token);
        } catch (e) {
          // Silent fail
        }
      }
    };

    window.addEventListener('fcm-token-updated', handleFCMTokenUpdate);
    window.addEventListener('fcm-token-ready', handleFCMTokenUpdate);

    if (window.requestFCMToken) {
      window.requestFCMToken();
    }

    try {
      const storedToken = localStorage.getItem('fcmToken');
      if (storedToken) {
        window.fcmToken = storedToken;
      }
    } catch (e) {
      // Silent fail
    }

    return () => {
      window.removeEventListener('fcm-token-updated', handleFCMTokenUpdate);
      window.removeEventListener('fcm-token-ready', handleFCMTokenUpdate);
    };
  }, []);
};

export default useFcmToken;